import React from 'react';
import HomeDepotConfig from './HomeDepotConfig';
import HelmetHouseConfig from './HelmetHouseConfig';
import VitacostConfig from './VitacostConfig';
import BestBuyConfig from './BestBuyConfig';
import WebstaurantstoreConfig from './WebstaurantstoreConfig';
import WpsConfig from './WpsConfig';
import ZoroConfig from './ZoroConfig';
import IherbConfig from './IherbConfig';
import PureFormulasConfig from './PureFormulasConfig';
import WalmartConfig from './WalmartConfig';
import MacysConfig from './MacysConfig';
import BoscovsConfig from './BoscovsConfig';

// Interface para configuração genérica
interface ConfigProps {
  stockLevel: number;
  batchSize: number;
  requestsPerSecond: number;
  handlingTimeOmd?: number; // Compatibilidade com providers antigos
  storeHandlingTime?: number; // Novo nome padronizado
  providerSpecificHandlingTime: number;
  updateFlagValue: number;
  minimumStockThreshold: number; // Novo: estoque mínimo configurável
  priceMarkupPercentage?: number; // Phase 2.1 - Markup %
}

interface ProviderConfigFactoryProps {
  providerId: string;
  config: ConfigProps;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAvailabilityMapChange?: (field: string, value: number) => void;
}

/**
 * Factory para selecionar o componente de configuração correto com base no tipo de fornecedor
 */
const ProviderConfigFactory: React.FC<ProviderConfigFactoryProps> = ({ 
  providerId, 
  config, 
  onChange,
  onAvailabilityMapChange
}) => {
  // Selecionar o componente de configuração com base no providerId
  switch (providerId) {
    case 'homedepot':
      return <HomeDepotConfig config={config as any} onChange={onChange} />;
    
    case 'zoro':
      return <ZoroConfig config={config as any} onChange={onChange} onAvailabilityMapChange={onAvailabilityMapChange} />;
    
    case 'vitacost':
      return <VitacostConfig config={config as any} onChange={onChange} />;
    
    case 'walmart':
      return <WalmartConfig config={config as any} onChange={onChange} />;
    
    case 'iherb':
      return <IherbConfig config={config as any} onChange={onChange} />;
    
    case 'pureformulas':
      return <PureFormulasConfig config={config as any} onChange={onChange} />;

    case 'boscovs':
      return <BoscovsConfig config={config as any} onChange={onChange} />;
    
    case 'bestbuy':
      return <BestBuyConfig config={config as any} onChange={onChange} />;
    
    case 'webstaurantstore':
      return <WebstaurantstoreConfig config={config as any} onChange={onChange} />;
    case 'wps':
      return <WpsConfig config={config as any} onChange={onChange} />;
    
    case 'helmethouse':
      return <HelmetHouseConfig config={config as any} onChange={onChange} />;
    case 'helmet_house':
      return <HelmetHouseConfig config={config as any} onChange={onChange} />;
    
    case 'macys':
      return <MacysConfig config={config as any} onChange={onChange} />;
    
    // Caso padrão - usar um formulário genérico
    default:
      return (
        <div className="space-y-4">
          <div>
            <label htmlFor="stockLevel" className="block text-sm font-medium text-gray-700 mb-1">
              Nível de Estoque
            </label>
            <input
              id="stockLevel"
              type="number"
              name="stockLevel"
              value={config.stockLevel}
              onChange={onChange}
              className="input"
              aria-label="Nível de estoque"
            />
          </div>
          
          <div>
            <label htmlFor="handlingTimeOmd" className="block text-sm font-medium text-gray-700 mb-1">
              Tempo de Manuseio OMD (dias)
            </label>
            <input
              id="handlingTimeOmd"
              type="number"
              name="handlingTimeOmd"
              value={config.handlingTimeOmd}
              onChange={onChange}
              className="input"
              aria-label="Tempo de manuseio da OMD em dias"
            />
          </div>
          
          <div>
            <label htmlFor="batchSize" className="block text-sm font-medium text-gray-700 mb-1">
              Tamanho do Lote
            </label>
            <input
              id="batchSize"
              type="number"
              name="batchSize"
              value={config.batchSize}
              onChange={onChange}
              className="input"
              aria-label="Tamanho do lote"
            />
          </div>
          
          <div>
            <label htmlFor="requestsPerSecond" className="block text-sm font-medium text-gray-700 mb-1">
              Requisições por Segundo
            </label>
            <input
              id="requestsPerSecond"
              type="number"
              name="requestsPerSecond"
              value={config.requestsPerSecond}
              onChange={onChange}
              className="input"
              aria-label="Requisições por segundo"
            />
          </div>
          
          <div>
            <label htmlFor="updateFlagValue" className="block text-sm font-medium text-gray-700 mb-1">
              Código de Atualização (ID da Loja)
            </label>
            <input
              id="updateFlagValue"
              type="number"
              name="updateFlagValue"
              value={config.updateFlagValue}
              onChange={onChange}
              className="input"
              aria-label="Código de atualização (ID da loja)"
            />
            <p className="text-xs text-gray-500 mt-1">
              Este código será usado para marcar produtos atualizados por esta loja. Use um valor único para cada loja.
            </p>
          </div>
          
          {/* Providers sem UI específica usam o formulário genérico acima */}
        </div>
      );
  }
};

export default ProviderConfigFactory; 